import {
  checkBookerEmail,
  checkBookerName,
  checkNationality,
  checkParticipantEmail,
  checkParticipantName,
  checkPhoneNumber,
  type RequiredFieldCheck,
  type RequiredFieldError,
} from '@/wabunka-src/common/features/Reservation/core/requiredFields/fieldChecks';
import { checkRequiredReservationQuestions } from '@/wabunka-src/common/features/Reservation/core/requiredFields/reservationQuestions';
import type { WabunkaReservationFormStep2 } from '@/wabunka-src/features/Experience/subFeatures/Reservation/models/wabunkaReservations';

export type ReservationSectionId = 'contactInfo' | 'additionalOptions' | 'hostDetails' | 'payment';

/** payment はカード情報が PSP の iframe 内にあり、利用規約同意も送信時の条件のため、充足を判定しない（D-012） */
export type FulfillableReservationSectionId = Exclude<ReservationSectionId, 'payment'>;

const SECTION_REQUIRED_FIELD_CHECKS: Record<FulfillableReservationSectionId, RequiredFieldCheck[]> = {
  contactInfo: [checkBookerName, checkBookerEmail, checkParticipantName, checkParticipantEmail],
  // 通訳オプションは選択欄の有無に関わらず既定値が入っているため、ゲストが埋める必須が無い（D-038）
  additionalOptions: [],
  hostDetails: [checkPhoneNumber, checkNationality, checkRequiredReservationQuestions],
};

/** 上の宣言順がそのまま画面に並ぶ順になる。送信時にどのセクションを開き直すかもこの順序で決める */
export const FULFILLABLE_RESERVATION_SECTION_IDS = Object.keys(SECTION_REQUIRED_FIELD_CHECKS) as readonly FulfillableReservationSectionId[];

/** 必須を持たないセクション（S2）は常に充足になるため、充足していてもゲストが中を見たかどうかは分からない */
export const hasReservationSectionRequiredFields = (sectionId: FulfillableReservationSectionId): boolean => SECTION_REQUIRED_FIELD_CHECKS[sectionId].length > 0;

/** セクションの Continue を止めている欄と、その理由 */
export const listReservationSectionErrors = (sectionId: FulfillableReservationSectionId, step2: WabunkaReservationFormStep2): RequiredFieldError[] =>
  SECTION_REQUIRED_FIELD_CHECKS[sectionId].flatMap((check) => check(step2));

export const isReservationSectionFulfilled = (sectionId: FulfillableReservationSectionId, step2: WabunkaReservationFormStep2): boolean => listReservationSectionErrors(sectionId, step2).length === 0;
